import { resolveSystemTypeConfig } from "../../utils/resolveSystemTypeConfig";
export const FOLLOW_UP_RESET = {
    followUpEligibility: null,
    followUpSelected: false,
    followUpGrid: false,
};
export const createFollowUpSlice = (set) => ({
    ...FOLLOW_UP_RESET,
    setFollowUpEligibility: (entries) => set({ followUpEligibility: entries }),
    setFollowUpSelected: (selected) => set({ followUpSelected: selected }),
    chooseFollowUpSlot: () => set({
        followUpGrid: true,
        followUpSelected: true,
        selectedSlot: null,
        selectedPack: null,
        selectedActiveSessionPack: null,
        bookingError: null,
        currentStep: "schedule",
    }),
    leaveFollowUpGrid: () => set({
        followUpGrid: false,
        followUpSelected: false,
        selectedSlot: null,
        bookingError: null,
        currentStep: "schedule",
    }),
});
export function selectedPatientFollowUp(state) {
    if (resolveSystemTypeConfig(state.activeSystemType).bookingMode === "qms") {
        return null;
    }
    if (state.patientTab !== "existing" || !state.selectedPatient)
        return null;
    const entry = state.followUpEligibility?.find((e) => e.patientId === Number(state.selectedPatient?.id));
    const eligibility = entry?.eligibility;
    if (!eligibility?.eligible || eligibility.parentAppointmentId == null) {
        return null;
    }
    return eligibility;
}
export function appliedFollowUp(state) {
    if (!state.followUpSelected)
        return null;
    if (state.selectedPack || state.selectedActiveSessionPack)
        return null;
    const eligibility = selectedPatientFollowUp(state);
    if (!eligibility || !followUpFitsSlot(eligibility, state.selectedSlot)) {
        return null;
    }
    return eligibility;
}
const FOLLOW_UP_ERRORS = {
    FOLLOW_UP_NOT_ELIGIBLE: "This patient is no longer eligible for a follow-up with this doctor. Please book a regular visit.",
    PARENT_NOT_ELIGIBLE: "This patient is no longer eligible for a follow-up with this doctor. Please book a regular visit.",
    FOLLOW_UP_DURATION_MISMATCH: "This time slot doesn't match the follow-up visit length. Please choose another slot.",
};
export function followUpBookingError(e) {
    const message = e
        ?.response?.data?.message;
    return typeof message === "string" ? (FOLLOW_UP_ERRORS[message] ?? null) : null;
}
function slotMinutes(slot) {
    const toMinutes = (value) => {
        const time = value.includes("T") ? value.split("T").pop() : value;
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
    };
    return toMinutes(slot.end) - toMinutes(slot.start);
}
export function followUpFitsSlot(eligibility, slot) {
    const mins = eligibility.followUpDurationMins;
    if (mins == null || mins <= 0)
        return true;
    return !!slot && slotMinutes(slot) === mins;
}
